window.EF = require('ef/ef');
require('ef-requires');
require('services/session-service');

var Layout = require('views/layout');
var ContentService = require('services/content-service');
var CourseSettingsService = require('services/course-settings-service');
var LocaleService = require('services/locale-service');
var AudioService = require('services/audio-service');
var PortfolioService = require('services/portfolio-service');
var NavigationService = require('services/navigation-service');
var SurveyService = require('services/survey-service');
var SyncService = require('services/sync-service');
var AssessmentService = require('services/assessment-service');
var EvaluationService = require('services/evaluation-service');
var utils = require('lib/utils');

export default Chaplin.Application.extend({
  title: 'EverFi SDK',
  initialize: function(options){
    _.defaults(options, utils.tryRequire('local-data/config.json'), {
      config: {
        settings: {
          local: true,
          env: 'dev'
        },
        enrollment: {
          id: 1,
          name: 'Charles Xavier',
          schoolName: 'EverFi Institute',
          className: 'Spring 2013',
          certified: false,
          autoPlay: false
        },
        i18n: {
        }
      }
    });
    // HR config passed here
    this.config = options.config;
    // if the config decides to send the app elsewhere replace the hash now
    // this prevents the router from routing to the menu and then to the page
    // if the menu was loaded and then quickly switched to another page
    // the menu would dispose itself before it was done loading and cause some undefined errors
    if(this.config && this.config.other && this.config.other.start) {
      window.location.replace(`#${this.config.other.start}`);
    }

    utils.initialize(this.config.settings);
    NavigationService.initialize(this.config.settings);
    Chaplin.Application.prototype.initialize.apply(this, arguments);
  },
  start: function(args) {
    var self = this;
    this.setCSRFToken();
    CourseSettingsService.initialize(this.config.settings).done(function() {
      $.when(ContentService.initialize(),
        LocaleService.initialize(self.config.i18n))
        .done(function () {
          var groupsJson  = ContentService.groups;
          var modulesJson = ContentService.modules;
          var enrollment  = self.config.enrollment;

          EF.init(groupsJson, modulesJson, enrollment, {
            local: self.config.settings.local,
            apiOnly: true,
            autoNextActivity: true,
            loadActivityProgresses: self.config.settings.progressProvider !== 'content-service',
            evaluations: self.config.evaluations
          }, self.config.settings);
          AudioService.initialize();
          SurveyService.initialize(self.config.surveys);
          AssessmentService.initialize(self.config.assessments);
          EvaluationService.initialize(self.config.evaluations);

          window.addEventListener('message', (event) => {
            if(event.data.event_type === 'reload-evaluation') {
              EvaluationService.refreshResponseSet(event.data.slug);
            }
          }, false);
        }).fail(function(){
          console.log("Content Loading Failed! Maybe you have an error in your JSON?");
        });
    });

    if(this.config.settings.local){
      SyncService.initialize(this.config.settings);
    }


    EF.on('ready', _.bind(function(){
      var args = Array.prototype.slice.call(arguments);
      if (CourseSettingsService.get('portfolio')){
        PortfolioService.initialize();
      }
      if (EF.options.local){
        EF.activityProgresses.fetch();
        EF.customizations.fetch();
      }

      EF.ContentProvider.ResourceService.loadResources();

      var customModules = EF.customizations.get('content-module-customization');
      if (customModules){
        var newModules = EF.modules.filter((mod) => customModules.get('modules').indexOf(mod.get('key')) > -1);
        customModules.get('modules').forEach((mod, i) => EF.modules.find({ key: mod }).set('index', i));
        EF.modules = new EF.Collections.ModulesCollection(newModules);
        EF.modules.sort();
        customModules.set('force_order', customModules.get('force_order') == "true");
        EF.groups.each((g) => {
          g.modules.sort();
          g.modules.forEach((m) => {
            if(m && m.get('key') !== undefined && EF.modules.find({key: m.get('key')}) === undefined) {
              // Inconsistency, this module is in groups but not in EF.modules
              // Get rid of it so it doesn't get in the way of unlocking the next module
              g.modules.remove(m);
            }
          });
          if (g.get('custom_in_order')){
            g.set('in_order', customModules.get('force_order'));
          }
        });
      }
      Chaplin.Application.prototype.start.apply(this, args);
      if (CourseSettingsService.get('startupScript')){
        require(CourseSettingsService.get('startupScript'));
      }

      if (CourseSettingsService.get('menu') && CourseSettingsService.get('menu').skip){
        var firstIncomplete;
        if(CourseSettingsService.get('menu').groups) {
          firstIncomplete = EF.groups.currentGroup().getStartingModule();
        } else {
          firstIncomplete = EF.modules.getStartingModule();
        }
        this.router.route({ url: firstIncomplete.get('key') });
      }
    }, this));

    this.router.subscribeEvent("router:match", this.trackPageView);
    this.router.subscribeEvent("router:match", this.postMessageNewUrl);
  },
  trackPageView: function(route){
    if(window.ga && typeof window.ga.getAll === 'function'){
      var url = location.pathname + '#' + route.path;
      window.ga.getAll().forEach((tracker) => {
        tracker.send('pageview', url.replace(/^!/, ''));
      });
    }
  },
  postMessageNewUrl(route){
    if (window.parent){
      window.parent.postMessage({ event_type: 'url-change', new_url: `${location.origin}/${location.pathname}#${route.path}` }, '*');
    }
  },
  setCSRFToken: function(){
    let funcs = {
     csrfToken: function() {
       return $('meta[name=csrf-token]').attr('content');
      },

      // Make sure that every Ajax request sends the CSRF token
      CSRFProtection: function(xhr) {
        var token = funcs.csrfToken();
        if (token) xhr.setRequestHeader('X-CSRF-Token', token);
      }
    };

    $.ajaxPrefilter(function(options, originalOptions, xhr){ if ( !options.crossDomain ) { funcs.CSRFProtection(xhr); }});
  }

});
